import React from "react";

import {Avatar, AvatarProps, Badge} from "antd";
import MetaAntd from "antd/es/card/Meta";
import { PictureFilled } from "@ant-design/icons";

import './style.scss';
import OptionalLink from "../OptionalLink";

export interface MetaInterface {
  url?: string;
  avatar?: string;
  fallback?: React.FC;
  shape?: AvatarProps['shape'];
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  size?: 'xsmall' | 'small' | 'medium' | 'large';
  className?: string;
  badge?: string;
}

const Meta = (
  {
    url,
    avatar,
    description,
    title,
    className,
    badge,
    fallback = PictureFilled,
    shape = 'square',
    size = 'large'
  }: MetaInterface
) => {
  let avatarSize;

  switch (size) {
    case 'xsmall':
      avatarSize = 30;
      break;
    case 'small':
      avatarSize = 35;
      break;
    case 'medium':
      avatarSize = 50;
      break;
    case 'large':
      avatarSize = 75;
      break;
    default:
      avatarSize = 75;
  }

  const renderAvatar = () => {
    if (badge) {
      return (
        <Badge dot color={badge}>
          <Avatar
            shape={shape}
            size={avatarSize}
            src={avatar}
            icon={React.createElement(fallback)}
          />
        </Badge>
      )
    } else {
      return (
        <Avatar
          shape={shape}
          size={avatarSize}
          src={avatar}
          icon={React.createElement(fallback)}
        />
      )
    }
  }

  return (
    <OptionalLink link={url}>
      <MetaAntd
        className={`v-meta o-${size} ${className}`}
        avatar={renderAvatar()}
        title={title}
        description={description}
      />
    </OptionalLink>
  );
}

export default Meta;
